// @ts-nocheck
// fetch request details
// here will be funcitons
// 1. event info
// 2. contact info
// 3. fetch coordinators
// 4. fetch sessions
// 5. set eventInfo
// 5. set eventInfo
export const FETCH_EVENT_DETAILS_REQUEST = "FETCH_EVENT_DETAILS_REQUEST";
export const FETCH_EVENT_DETAILS_SUCCESS = "FETCH_EVENT_DETAILS_SUCCESS";
export const FETCH_EVENT_DETAILS_POSITIONS_SUCCESS =
  "FETCH_EVENT_DETAILS_POSITIONS_SUCCESS";
export const FETCH_EVENT_DETAILS_FAILURE = "FETCH_EVENT_DETAILS_FAILURE";
// Rede de segurança do `finally` de `fetchEventDetailsAction`: desliga SÓ os loaders,
// sem tocar em dado já carregado (ao contrário de _FAILURE, que também é um estado de erro).
// Existe porque `isLoading` preso em `true` vira spinner eterno e MUDO na tela de detalhe.
export const FETCH_EVENT_DETAILS_STOP_LOADING =
  "FETCH_EVENT_DETAILS_STOP_LOADING";

// assign coordinator to event
// 1. set coordinators for event
export const ASSIGN_COORDINATOR_REQUEST = "ASSIGN_COORDINATOR_REQUEST";
export const ASSIGN_COORDINATOR_SUCCESS = "ASSIGN_COORDINATOR_SUCCESS";
export const ASSIGN_COORDINATOR_FAILURE = "ASSIGN_COORDINATOR_FAILURE";

// remove session from event
// 1. delete session  from event
export const REMOVE_SESSION_REQUEST = "REMOVE_SESSION_REQUEST";
export const REMOVE_SESSION_SUCCESS = "REMOVE_SESSION_SUCCESS";
export const REMOVE_SESSION_FAILURE = "REMOVE_SESSION_FAILURE";

// remove position from event
// 1. delete porition from session
export const REMOVE_POSITION_REQUEST = "REMOVE_POSITION_REQUEST";
export const REMOVE_POSITION_SUCCESS = "REMOVE_POSITION_SUCCESS";
export const REMOVE_POSITION_FAILURE = "REMOVE_POSITION_FAILURE";

// remove coordinator from event
export const REMOVE_COORDINATOR_REQUEST = "REMOVE_COORDINATOR_REQUEST";
export const REMOVE_COORDINATOR_SUCCESS = "REMOVE_COORDINATOR_SUCCESS";
export const REMOVE_COORDINATOR_FAILURE = "REMOVE_COORDINATOR_FAILURE";

// add time difference
export const ADD_TIME_DIFFERENCE = "ADD_TIME_DIFFERENCE";

// submit estimates
export const SUBMIT_ESTIMATE_REQUEST = "SUBMIT_ESTIMATE_REQUEST";
export const SUBMIT_ESTIMATE_SUCCESS = "SUBMIT_ESTIMATE_SUCCESS";
export const SUBMIT_ESTIMATE_FAILURE = "SUBMIT_ESTIMATE_FAILURE";

// assign contractor to position
export const ASSIGN_CONTRACTOR_REQUEST = "ASSIGN_CONTRACTOR_REQUEST";
export const ASSIGN_CONTRACTOR_SUCCESS = "ASSIGN_CONTRACTOR_SUCCESS";
export const ASSIGN_CONTRACTOR_FAILURE = "ASSIGN_CONTRACTOR_FAILURE";

// update position
export const UPDATE_SESSION_POSITION_REQUEST =
  "UPDATE_SESSION_POSITION_REQUEST";
export const UPDATE_SESSION_POSITION_SUCCESS =
  "UPDATE_SESSION_POSITION_SUCCESS";
export const UPDATE_SESSION_POSITION_FAILURE =
  "UPDATE_SESSION_POSITION_FAILURE";

// update session
export const UPDATE_SESSION_REQUEST = "UPDATE_SESSION_REQUEST";
export const UPDATE_SESSION_SUCCES = "UPDATE_SESSION_SUCCESS";
export const UPDATE_SESSION_FAILURE = "UPDATE_SESSION_FAILURE";

// event edited after estimate is generated
export const EVENT_EDITED_AFTER_ESTIMATE_REQUEST =
  "EVENT_EDITED_AFTER_ESTIMATE_REQUEST";
export const EVENT_EDITED_AFTER_ESTIMATE_SUCCESS =
  "EVENT_EDITED_AFTER_ESTIMATE_SUCCESS";
export const EVENT_EDITED_AFTER_ESTIMATE_FAILURE =
  "EVENT_EDITED_AFTER_ESTIMATE_FAILURE";

// set eventInfo
export const SET_EVENT_INFO = "SET_EVENT_INFO";

// toggle show contractor initials
export const TOGGLE_SHOW_CONTRACTOR_INITIALS_REQUEST =
  "TOGGLE_SHOW_CONTRACTOR_INITIALS_REQUEST";
export const TOGGLE_SHOW_CONTRACTOR_INITIALS_SUCCESS =
  "TOGGLE_SHOW_CONTRACTOR_INITIALS_SUCCESS";
export const TOGGLE_SHOW_CONTRACTOR_INITIALS_FAILURE =
  "TOGGLE_SHOW_CONTRACTOR_INITIALS_FAILURE";

// set time for position field
export const SET_FIELD_FOR_POSITION = "SET_FIELD_FOR_POSITION";

// set time for positions field
export const SET_FIELD_VALUES_FOR_POSITIONS = "SET_FIELD_VALUES_FOR_POSITIONS";

// add new log
export const CREATE_LOG_REQUEST = "CREATE_LOG_REQUEST";
export const CREATE_LOG_SUCCESS = "CREATE_LOG_SUCCESS";
export const CREATE_LOG_FAILURE = "CREATE_LOG_FAILURE";

// fetch logs
export const FETCH_LOGS_REQUEST = "FETCH_LOGS_REQUEST";
export const FETCH_LOGS_SUCCESS = "FETCH_LOGS_SUCCESS";
export const FETCH_LOGS_FAILURE = "FETCH_LOGS_FAILURE";

// refresh event
export const REFRESH_EVENT_REQUEST = "REFRESH_EVENT_REQUEST";
export const REFRESH_EVENT_SUCCESS = "REFRESH_EVENT_SUCCESS";
export const REFRESH_EVENT_FAILURE = "REFRESH_EVENT_FAILURE";

// mark event as complete
export const MARK_EVENT_COMPLETE_REQUEST = "MARK_EVENT_COMPLETE_REQUEST";
export const MARK_EVENT_COMPLETE_SUCCESS = "MARK_EVENT_COMPLETE_SUCCESS";
export const MARK_EVENT_COMPLETE_FAILURE = "MARK_EVENT_COMPLETE_FAILURE";

// add new position
export const ADD_NEW_POSITION_REQUEST = "ADD_NEW_POSITION_REQUEST";
export const ADD_NEW_POSITION_SUCCESS = "ADD_NEW_POSITION_SUCCESS";
export const ADD_NEW_POSITION_FAILURE = "ADD_NEW_POSITION_FAILURE";

// send opportunity to contractors
export const SEND_OPPORTUNITY_TO_CONTRACTORS_REQUEST =
  "SEND_OPPORTUNITY_TO_CONTRACTORS_REQUEST";
export const SEND_OPPORTUNITY_TO_CONTRACTORS_SUCCESS =
  "SEND_OPPORTUNITY_TO_CONTRACTORS_SUCCESS";
export const SEND_OPPORTUNITY_TO_CONTRACTORS_FAILURE =
  "SEND_OPPORTUNITY_TO_CONTRACTORS_FAILURE";

// fetch schedule resources data for that event
export const FETCH_SCHEDULE_RESOURCES_REQUEST =
  "FETCH_SCHEDULE_RESOURCES_REQUEST";
export const FETCH_SCHEDULE_RESOURCES_SUCCESS =
  "FETCH_SCHEDULE_RESOURCES_SUCCESS";
export const FETCH_SCHEDULE_RESOURCES_FAILURE =
  "FETCH_SCHEDULE_RESOURCES_FAILURE";

// fetch content resources data for that event
export const FETCH_CONTENT_RESOURCES_REQUEST =
  "FETCH_CONTENT_RESOURCES_REQUEST";
export const FETCH_CONTENT_RESOURCES_SUCCESS =
  "FETCH_CONTENT_RESOURCES_SUCCESS";
export const FETCH_CONTENT_RESOURCES_FAILURE =
  "FETCH_CONTENT_RESOURCES_FAILURE";

// upload schedule resources data for that event
export const UPLOAD_SCHEDULE_RESOURCES_REQUEST =
  "UPLOAD_SCHEDULE_RESOURCES_REQUEST";
export const UPLOAD_SCHEDULE_RESOURCES_SUCCESS =
  "UPLOAD_SCHEDULE_RESOURCES_SUCCESS";
export const UPLOAD_SCHEDULE_RESOURCES_FAILURE =
  "UPLOAD_SCHEDULE_RESOURCES_FAILURE";

// upload content resources data for that event
export const UPLOAD_CONTENT_RESOURCES_REQUEST =
  "UPLOAD_CONTENT_RESOURCES_REQUEST";
export const UPLOAD_CONTENT_RESOURCES_SUCCESS =
  "UPLOAD_CONTENT_RESOURCES_SUCCESS";
export const UPLOAD_CONTENT_RESOURCES_FAILURE =
  "UPLOAD_CONTENT_RESOURCES_FAILURE";

// delete schedule resources data for that event
export const DELETE_SCHEDULE_RESOURCES_REQUEST =
  "DELETE_SCHEDULE_RESOURCES_REQUEST";
export const DELETE_SCHEDULE_RESOURCES_SUCCESS =
  "DELETE_SCHEDULE_RESOURCES_SUCCESS";
export const DELETE_SCHEDULE_RESOURCES_FAILURE =
  "DELETE_SCHEDULE_RESOURCES_FAILURE";

// delete content resources data for that event
export const DELETE_CONTENT_RESOURCES_REQUEST =
  "DELETE_CONTENT_RESOURCES_REQUEST";
export const DELETE_CONTENT_RESOURCES_SUCCESS =
  "DELETE_CONTENT_RESOURCES_SUCCESS";
export const DELETE_CONTENT_RESOURCES_FAILURE =
  "DELETE_CONTENT_RESOURCES_FAILURE";

// delete all content files
export const DELETE_ALL_CONTENT_FILES_REQUEST =
  "DELETE_ALL_CONTENT_FILES_REQUEST";
export const DELETE_ALL_CONTENT_FILES_SUCCESS =
  "DELETE_ALL_CONTENT_FILES_SUCCESS";
export const DELETE_ALL_CONTENT_FILES_FAILURE =
  "DELETE_ALL_CONTENT_FILES_FAILURE";

// delete all schedule files
export const DELETE_ALL_SCHEDULE_FILES_REQUEST =
  "DELETE_ALL_SCHEDULE_FILES_REQUEST";
export const DELETE_ALL_SCHEDULE_FILES_SUCCESS =
  "DELETE_ALL_SCHEDULE_FILES_SUCCESS";
export const DELETE_ALL_SCHEDULE_FILES_FAILURE =
  "DELETE_ALL_SCHEDULE_FILES_FAILURE";

// change assign by
export const CHANGE_ASSIGN_BY_REQUEST = "CHANGE_ASSIGN_BY_REQUEST";
export const CHANGE_ASSIGN_BY_SUCCESS = "CHANGE_ASSIGN_BY_SUCCESS";
export const CHANGE_ASSIGN_BY_FAILURE = "CHANGE_ASSIGN_BY_FAILURE";

// check for schedule conflicts
export const CHECK_SCHEDULE_CONFLICTS_REQUEST =
  "CHECK_SCHEDULE_CONFLICTS_REQUEST";
export const CHECK_SCHEDULE_CONFLICTS_SUCCESS =
  "CHECK_SCHEDULE_CONFLICTS_SUCCESS";
export const CHECK_SCHEDULE_CONFLICTS_FAILURE =
  "CHECK_SCHEDULE_CONFLICTS_FAILURE";

// approve time
export const APPROVE_TIME_REQUEST = "APPROVE_TIME_REQUEST";
export const APPROVE_TIME_SUCCESS = "APPROVE_TIME_SUCCESS";
export const APPROVE_TIME_FAILURE = "APPROVE_TIME_FAILURE";

// set Event details tab data
export const EVENT_DETAILS_TAB_SELECTED_SESSION =
  "EVENT_DETAILS_TAB_SELECTED_SESSION";
export const EVENT_DETAILS_TAB_SELECTED_PAGE =
  "EVENT_DETAILS_TAB_SELECTED_PAGE";

// reported issues tabs
export const EVENT_REPORTED_TAB_SELECTED_SESSION =
  "EVENT_REPORTED_TAB_SELECTED_SESSION";
export const EVENT_REPORTED_TAB_SELECTED_PAGE =
  "EVENT_REPORTED_TAB_SELECTED_PAGE";

//create notes
export const EVENT_ADD_NOTE_REQUEST = "EVENT_ADD_NOTE_REQUEST ";
export const EVENT_ADD_NOTE_SUCCESS = "EVENT_ADD_NOTE_SUCCESS";
export const EVENT_ADD_NOTE_FAILURE = "EVENT_ADD_NOTE_FAILURE";

//getAssignedUsersOfEvent
export const FETCH_ASSIGNED_USERS_REQUEST = "FETCH_ASSIGNED_USERS_REQUEST ";
export const FETCH_ASSIGNED_USERS_SUCCESS = "FETCH_ASSIGNED_USERS_SUCCESS";
export const FETCH_ASSIGNED_USERS_FAILURE = "FETCH_ASSIGNED_USERS_FAILURE";

//getOneOnOneNotes
// export const FETCH_ONE_ON_ONE_NOTES_REQUEST = "FETCH_ONE_ON_ONE_NOTES_REQUEST";
// export const FETCH_ONE_ON_ONE_NOTES_SUCCESS = "FETCH_ONE_ON_ONE_NOTES_SUCCESS";
// export const FETCH_ONE_ON_ONE_NOTES_FAILURE = "FETCH_ONE_ON_ONE_NOTES_FAILURE";

//getOneToOneRooms
export const FETCH_ONE_ON_ONE_ROOMS_REQUEST = "FETCH_ONE_ON_ONE_ROOMS_REQUEST";
export const FETCH_ONE_ON_ONE_ROOMS_SUCCESS = "FETCH_ONE_ON_ONE_ROOMS_SUCCESS";
export const FETCH_ONE_ON_ONE_ROOMS_FAILURE = "FETCH_ONE_ON_ONE_ROOMS_FAILURE";

// add new note chat room
export const ADD_NEW_NOTE_CHAT_ROOM = "ADD_NEW_NOTE_CHAT_ROOM";

//markNoteResolved
export const FETCH_MARK_NOTE_RESOLVED_REQUEST =
  "FETCH_MARK_NOTE_RESOLVED_REQUEST";
export const FETCH_MARK_NOTE_RESOLVED_SUCCESS =
  "FETCH_MARK_NOTE_RESOLVED_SUCCESS";
export const FETCH_MARK_NOTE_RESOLVED_FAILURE =
  "FETCH_MARK_NOTE_RESOLVED_FAILURE";

// create estimate config
export const CREATE_ESTIMATE_CONFIG_REQUEST = "CREATE_ESTIMATE_CONFIG_REQUEST";
export const CREATE_ESTIMATE_CONFIG_SUCCESS = "CREATE_ESTIMATE_CONFIG_SUCCESS";
export const CREATE_ESTIMATE_CONFIG_FAILURE = "CREATE_ESTIMATE_CONFIG_FAILURE";

// update estimate config
export const UPDATE_ESTIMATE_CONFIG_REQUEST = "UPDATE_ESTIMATE_CONFIG_REQUEST";
export const UPDATE_ESTIMATE_CONFIG_SUCCESS = "UPDATE_ESTIMATE_CONFIG_SUCCESS";
export const UPDATE_ESTIMATE_CONFIG_FAILURE = "UPDATE_ESTIMATE_CONFIG_FAILURE";

// delete estimate config
export const DELETE_ESTIMATE_CONFIG_REQUEST = "DELETE_ESTIMATE_CONFIG_REQUEST";
export const DELETE_ESTIMATE_CONFIG_SUCCESS = "DELETE_ESTIMATE_CONFIG_SUCCESS";
export const DELETE_ESTIMATE_CONFIG_FAILURE = "DELETE_ESTIMATE_CONFIG_FAILURE";

// fetch estimate config
export const FETCH_ESTIMATE_CONFIG_REQUEST = "FETCH_ESTIMATE_CONFIG_REQUEST";
export const FETCH_ESTIMATE_CONFIG_SUCCESS = "FETCH_ESTIMATE_CONFIG_SUCCESS";
export const FETCH_ESTIMATE_CONFIG_FAILURE = "FETCH_ESTIMATE_CONFIG_FAILURE";

// submit estimate config
export const SUBMIT_ESTIMATE_CONFIG_REQUEST = "SUBMIT_ESTIMATE_CONFIG_REQUEST";
export const SUBMIT_ESTIMATE_CONFIG_SUCCESS = "SUBMIT_ESTIMATE_CONFIG_SUCCESS";
export const SUBMIT_ESTIMATE_CONFIG_FAILURE = "SUBMIT_ESTIMATE_CONFIG_FAILURE";

// submit invoice config
export const SUBMIT_INVOICE_CONFIG_REQUEST = "SUBMIT_INVOICE_CONFIG_REQUEST";
export const SUBMIT_INVOICE_CONFIG_SUCCESS = "SUBMIT_INVOICE_CONFIG_SUCCESS";
export const SUBMIT_INVOICE_CONFIG_FAILURE = "SUBMIT_INVOICE_CONFIG_FAILURE";

// get invoice config
export const FETCH_INVOICE_CONFIG_REQUEST = "FETCH_INVOICE_CONFIG_REQUEST";
export const FETCH_INVOICE_CONFIG_SUCCESS = "FETCH_INVOICE_CONFIG_SUCCESS";
export const FETCH_INVOICE_CONFIG_FAILURE = "FETCH_INVOICE_CONFIG_FAILURE";

// accept estimate config
export const ACCEPT_ESTIMATE_CONFIG_REQUEST = "ACCEPT_ESTIMATE_CONFIG_REQUEST";
export const ACCEPT_ESTIMATE_CONFIG_SUCCESS = "ACCEPT_ESTIMATE_CONFIG_SUCCESS";
export const ACCEPT_ESTIMATE_CONFIG_FAILURE = "ACCEPT_ESTIMATE_CONFIG_FAILURE";

// assign contractor to multiple positions
export const ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_REQUEST =
  "ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_REQUEST";
export const ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_SUCCESS =
  "ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_SUCCESS";
export const ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_FAILURE =
  "ASSIGN_CONTRACTOR_MULTIPLE_POSITIONS_FAILURE";

// update assign by of multiple positions
export const UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_REQUEST =
  "UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_REQUEST";
export const UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_SUCCESS =
  "UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_SUCCESS";
export const UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_FAILURE =
  "UPDATE_ASSIGNBY_MUTIPLE_POSITIONS_FAILURE";

// half day click for event handler
export const HALF_DAY_EVENT_CLICK_REQUEST = "HALF_DAY_EVENT_CLICK_REQUEST";
export const HALF_DAY_EVENT_CLICK_SUCCESS = "HALF_DAY_EVENT_CLICK_SUCCESS";
export const HALF_DAY_EVENT_CLICK_FAILURE = "HALF_DAY_EVENT_CLICK_FAILURE";

// half day click for position
export const HALF_DAY_POSITION_CLICK_REQUEST =
  "HALF_DAY_POSITION_CLICK_REQUEST";
export const HALF_DAY_POSITION_CLICK_SUCCESS =
  "HALF_DAY_POSITION_CLICK_SUCCESS";
export const HALF_DAY_POSITION_CLICK_FAILURE =
  "HALF_DAY_POSITION_CLICK_FAILURE";

// override click for position
export const OVERRIDE_POSITION_CLICK_REQUEST =
  "OVERRIDE_POSITION_CLICK_REQUEST";
export const OVERRIDE_POSITION_CLICK_SUCCESS =
  "OVERRIDE_POSITION_CLICK_SUCCESS";
export const OVERRIDE_POSITION_CLICK_FAILURE =
  "OVERRIDE_POSITION_CLICK_FAILURE";

// update subtotal type
export const UPDATE_SUBTOTAL_TYPE_REQUEST = "UPDATE_SUBTOTAL_TYPE_REQUEST";
export const UPDATE_SUBTOTAL_TYPE_SUCCESS = "UPDATE_SUBTOTAL_TYPE_SUCCESS";
export const UPDATE_SUBTOTAL_TYPE_FAILURE = "UPDATE_SUBTOTAL_TYPE_FAILURE";

// fetch reimbursement category
export const FETCH_REIMBURSEMENT_CATEGORY_REQUEST =
  "FETCH_REIMBURSEMENT_CATEGORY_REQUEST";
export const FETCH_REIMBURSEMENT_CATEGORY_SUCCESS =
  "FETCH_REIMBURSEMENT_CATEGORY_SUCCESS";
export const FETCH_REIMBURSEMENT_CATEGORY_FAILURE =
  "FETCH_REIMBURSEMENT_CATEGORY_FAILURE";

// delete reimbursement category
export const DELETE_REIMBURSEMNET_CATEGORY_REQUEST =
  "DELETE_REIMBURSEMNET_CATEGORY_REQUEST";
export const DELETE_REIMBURSEMNET_CATEGORY_SUCCESS =
  "DELETE_REIMBURSEMNET_CATEGORY_SUCCESS";
export const DELETE_REIMBURSEMNET_CATEGORY_FAILURE =
  "DELETE_REIMBURSEMNET_CATEGORY_FAILURE";

// update reimbursement action
export const ADD_REIMBURSEMENT_CATEGORY_REQUEST =
  "ADD_REIMBURSEMENT_CATEGORY_REQUEST";
export const ADD_REIMBURSEMENT_CATEGORY_SUCCESS =
  "ADD_REIMBURSEMENT_CATEGORY_SUCCESS";
export const ADD_REIMBURSEMENT_CATEGORY_FAILURE =
  "ADD_REIMBURSEMENT_CATEGORY_FAILURE";

// get reimbursement amount
export const GET_REIMBURSEMENT_AMOUNT_REQUEST =
  "GET_REIMBURSEMENT_AMOUNT_REQUEST";
export const GET_REIMBURSEMENT_AMOUNT_SUCCESS =
  "GET_REIMBURSEMENT_AMOUNT_SUCCESS";
export const GET_REIMBURSEMENT_AMOUNT_FAILURE =
  "GET_REIMBURSEMENT_AMOUNT_FAILURE";

// submit invoice data
export const SUBMIT_INVOICE_DATA_REQUEST = "SUBMIT_INVOICE_DATA_REQUEST";
export const SUBMIT_INVOICE_DATA_SUCCESS = "SUBMIT_INVOICE_DATA_SUCCESS";
export const SUBMIT_INVOICE_DATA_FAILURE = "SUBMIT_INVOICE_DATA_FAILURE";

// get invoice data
export const GET_INVOICE_DATA_REQUEST = "GET_INVOICE_DATA_REQUEST";
export const GET_INVOICE_DATA_SUCCESS = "GET_INVOICE_DATA_SUCCESS";
export const GET_INVOICE_DATA_FAILURE = "GET_INVOICE_DATA_FAILURE";

// get all invoice data
export const GET_ALL_INVOICE_REQUEST = "GET_ALL_INVOICE_REQUEST";
export const GET_ALL_INVOICE_SUCCESS = "GET_ALL_INVOICE_SUCCESS";
export const GET_ALL_INVOICE_FAILURE = "GET_ALL_INVOICE_FAILURE";

// dismiss client changes
export const DISMISS_CLIENT_CHANGES_REQUEST = "DISMISS_CLIENT_CHANGES_REQUEST";
export const DISMISS_CLIENT_CHANGES_SUCCESS = "DISMISS_CLIENT_CHANGES_SUCCESS";
export const DISMISS_CLIENT_CHANGES_FAILURE = "DISMISS_CLIENT_CHANGES_FAILURE";

// fetch submitted invoices
export const FETCH_SUBMITTED_INVOICE_REQUEST =
  "FETCH_SUBMITTED_INVOICE_REQUEST";
export const FETCH_SUBMITTED_INVOICE_SUCCESS =
  "FETCH_SUBMITTED_INVOICE_SUCCESS";
export const FETCH_SUBMITTED_INVOICE_FAILURE =
  "FETCH_SUBMITTED_INVOICE_FAILURE";

// switch invoice config
export const SWITCH_INVOICE_CONFIG = "SWITCH_INVOICE_CONFIG";

// receive deposit invocie amount
export const GET_DEPOSIT_INVOICE_AMOUNT_REQUEST =
  "GET_DEPOSIT_INVOICE_AMOUNT_REQUEST";
export const GET_DEPOSIT_INVOICE_AMOUNT_SUCCESS =
  "GET_DEPOSIT_INVOICE_AMOUNT_SUCCESS";
export const GET_DEPOSIT_INVOICE_AMOUNT_FAILURE =
  "GET_DEPOSIT_INVOICE_AMOUNT_FAILURE";

// add extra email
export const ADD_EXTRA_EMAIL_REQUEST = "ADD_EXTRA_EMAIL_REQUEST";
export const ADD_EXTRA_EMAIL_SUCCESS = "ADD_EXTRA_EMAIL_SUCCESS";
export const ADD_EXTRA_EMAIL_FAILURE = "ADD_EXTRA_EMAIL_FAILURE";

// remove extra email
export const REMOVE_EXTRA_EMAIL_REQUEST = "REMOVE_EXTRA_EMAIL_REQUEST";
export const REMOVE_EXTRA_EMAIL_SUCCESS = "REMOVE_EXTRA_EMAIL_SUCCESS";
export const REMOVE_EXTRA_EMAIL_FAILURE = "REMOVE_EXTRA_EMAIL_FAILURE";

// position terms
export const POSITION_TERM_UPDATE_REQUEST = "POSITION_TERM_UPDATE_REQUEST";
export const POSITION_TERM_UPDATE_SUCCESS = "POSITION_TERM_UPDATE_SUCCESS";
export const POSITION_TERM_UPDATE_FAILURE = "POSITION_TERM_UPDATE_FAILURE";

// clear contractor different time
export const CLEAR_CONTRACTOR_DIFFERENT_TIME =
  "CLEAR_CONTRACTOR_DIFFERENT_TIME";

// unassign contractor from positions
export const UNASSIGN_CONTRACTOR_REQUEST = "UNASSIGN_CONTRACTOR_REQUEST";
export const UNASSIGN_CONTRACTOR_SUCCESS = "UNASSIGN_CONTRACTOR_SUCCESS";
export const UNASSIGN_CONTRACTOR_FAILURE = "UNASSIGN_CONTRACTOR_FAILURE";

// update positions for california contractor rate on event
export const CALIFORNIA_CONTRACTOR_RATE_EVENT_REQUEST =
  "CALIFORNIA_CONTRACTOR_RATE_EVENT_REQUEST";
export const CALIFORNIA_CONTRACTOR_RATE_EVENT_FAILURE =
  "CALIFORNIA_CONTRACTOR_RATE_EVENT_FAILURE";
export const CALIFORNIA_CONTRACTOR_RATE_EVENT_SUCCESS =
  "CALIFORNIA_CONTRACTOR_RATE_EVENT_SUCCESS";

// assign contractor tab meta data
export const ASSIGN_COORDINATOR_META_DATA = "ASSIGN_COORDINATOR_META_DATA";

// session management tab meta data
export const SESSION_MANAGEMENT_META_DATA = "SESSION_MANAGEMENT_META_DATA";

// refresh rate list for event
export const REFRESH_RATE_LIST_FOR_EVENT_REQUEST =
  "REFRESH_RATE_LIST_FOR_EVENT_REQUEST";
export const REFRESH_RATE_LIST_FOR_EVENT_SUCCESS =
  "REFRESH_RATE_LIST_FOR_EVENT_SUCCESS";
export const REFRESH_RATE_LIST_FOR_EVENT_FAILURE =
  "REFRESH_RATE_LIST_FOR_EVENT_FAILURE";

// update client contractor rates at once
export const ADD_UPDATE_CLIENT_CONTRACTOR_RATE_REQUEST =
  "ADD_UPDATE_CLIENT_CONTRACTOR_RATE_REQUEST";
export const ADD_UPDATE_CLIENT_CONTRACTOR_RATE_SUCCESS =
  "ADD_UPDATE_CLIENT_CONTRACTOR_RATE_SUCCESS";
export const ADD_UPDATE_CLIENT_CONTRACTOR_RATE_FAILURE =
  "ADD_UPDATE_CLIENT_CONTRACTOR_RATE_FAILURE";

// update po udpate needed key
export const UPDATE_PO_UPDATE_NEEDED_KEY = "UPDATE_PO_UPDATE_NEEDED_KEY";